import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "new-movie-wizard" }
const _hoisted_2 = {
  key: 0,
  class: "modal without-overlay"
}
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = {
  key: 2,
  class: "error"
}
const _hoisted_5 = { class: "form-actions" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h3", null, "Create a New Movie")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.handleSubmit, ["prevent"])
            }, [
              _createVNode($setup["FormGroup"], {
                label: "Name",
                for: "name",
                description: "The title of your movie."
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    id: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.form.name) = $event)),
                    required: ""
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.form.name]
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode($setup["FormGroup"], { for: "inputType" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "inputType",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.inputType) = $event))
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("option", { value: "manual" }, "I will enter the data manually", -1 /* CACHED */),
                    _createElementVNode("option", { value: "prompt" }, "Start with a prompt", -1 /* CACHED */),
                    _createElementVNode("option", { value: "script" }, "Start with the entire script", -1 /* CACHED */)
                  ]), 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.inputType]
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              ($setup.inputType === 'prompt')
                ? (_openBlock(), _createBlock($setup["FormGroup"], {
                    key: 0,
                    label: "Prompt",
                    for: "prompt",
                    description: "Describe your movie idea."
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("textarea", {
                        id: "prompt",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.form.prompt) = $event)),
                        rows: "3",
                        required: ""
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.form.prompt]
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              ($setup.inputType === 'script')
                ? (_openBlock(), _createBlock($setup["FormGroup"], {
                    key: 1,
                    label: "Script",
                    for: "script",
                    description: "Paste your full script."
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("textarea", {
                        id: "script",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.form.script) = $event)),
                        rows: "6",
                        required: ""
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.form.script]
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              ($setup.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.error), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: $setup.store.loading
                }, "Create Movie", 8 /* PROPS */, _hoisted_6)
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]))
      : ($setup.step === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[6] || (_cache[6] = [
            _createElementVNode("h2", null, "Creating Movie...", -1 /* CACHED */),
            _createElementVNode("p", null, "Your movie is being generated. This may take a moment.", -1 /* CACHED */),
            _createElementVNode("div", { class: "loading" }, "Waiting for job to complete...", -1 /* CACHED */)
          ])))
        : _createCommentVNode("v-if", true)
  ]))
}